import React, { FC } from 'react';
import * as Styled from './CollectionGrid.styles';
import { CollectionItem } from '../../../../../../../../MIT/Search/view/frontend/pages/ProductSearch/containers/CollectionsCarouselContainer/CollectionItem';
import useInViewAnalytics from '../../hooks/useInViewAnalytics';
import { sortedCollectionsType } from '../../types';

interface CollectionGridProps {
  collection?: sortedCollectionsType;
}

export const CollectionGrid: FC<CollectionGridProps> = ({ collection }) => {
  const { handleInViewChange } = useInViewAnalytics({
    campaigns: collection?.results || [],
    title: collection?.label || '',
    isInView: true,
  });

  return (
    <Styled.Content>
      {collection?.results.map((campaign, index) => (
        <CollectionItem
          key={campaign._id}
          campaign={campaign}
          collectionTitle={collection?.label}
          index={index}
          sendInViewChange={handleInViewChange}
          responsive
          eventLocation={null}
          inView
        />
      ))}
    </Styled.Content>
  );
};
